define('models/learningContent',[],
    function () {

        function LearningContent(spec) {
            this.id = spec.id;
            this.content = null;
        }

        return LearningContent;
    }
);
